import landscapeBackgroundUrl from '@/assets/images/LandscapeBackground.svg';
import portraitBackgroundUrl from '@/assets/images/PortraitBackground.svg';

/**
 * Перенос `lib/src/config/app_images.dart`.
 *
 * Оба файла рисуются фоном на весь экран (`AppBackground`), поэтому
 * экспортируются именно URL-строками, а не React-компонентами: инлайнить
 * их в разметку незачем, браузер закеширует файл как обычную картинку.
 */
export const AppImages = {
  landscapeBackground: landscapeBackgroundUrl,
  portraitBackground: portraitBackgroundUrl,
} as const;

export type AppImageName = keyof typeof AppImages;
